import React from 'react';

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Box, Button, Stack } from '@mui/material';

interface Props {
  selected?: boolean;
  onClick: () => void;
}

export const TreatmentOnGoingTabButton: React.FC<Props> = ({
  selected,
  onClick,
  children,
}) => {
  return (
    <Stack alignItems="center">
      <Button
        variant={selected ? 'contained' : 'text'}
        sx={{
          color: selected ? '#FFFFFF' : '#4B4B4B',
          borderRadius: '12px',
          height: '66px',
          minWidth: '118px',
          zIndex: 1,
        }}
        onClick={onClick}
      >
        {children}
      </Button>

      <Box sx={{ marginTop: '-12px' }} height={28}>
        {selected && <ArrowDropUpIcon sx={{ fontSize: 48 }} color="primary" />}
      </Box>
    </Stack>
  );
};
